/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Rahul Bagaria <Rahul@wakencode.com>, 6 2023
 *
 */

import SAIcon from "../../assets/images/sa-icon.png";

/**
 * This is a functional componant for Loading
 * @returns JSX for Loading
 */
export const Loading = () => {
  return (
    <div className="sa-loading-spinner">
      <img src={SAIcon} alt="Spinner" className="sa-spinner-image" />
    </div>
  );
};
